import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-ai-sourcing-profile-slider',
    templateUrl: './ai-sourcing-profile-slider.component.html',
    styleUrls: ['./ai-sourcing-profile-slider.component.scss'],
    standalone: false
})
export class AiSourcingProfileSliderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
